import { HEADER_TYPE } from "../constants/CustomTypes";

export const hideEmptyFields = (params: any, schema: any, uiSchema: any, formData: any) => {
  const properties = schema.properties;

  Object.keys(properties).forEach((key) => {
    const data = formData[key];
    const propSchema = properties[key];
    const noValue = typeof data === "undefined";
    const stringIsEmpty = typeof data === "string" ? (!data || data.replace(/\s/g, "") === "") : false;
    const arrayIsEmpty = Array.isArray(data) ? !data.length : false;
    const emptyObject = data instanceof Object ? Object.keys(data).length < 1 : false;

    if (propSchema?.type === HEADER_TYPE) {
      return;
    }

    if (noValue || stringIsEmpty || arrayIsEmpty) {
      let prevUiSchema = uiSchema[key];
      uiSchema[key] = {
        ...(prevUiSchema || {}),
        "ui:hidden": true,
        "ui:widget": "hidden",
      };
    }

    if (emptyObject) {
      let prevUiSchema = uiSchema[key];
      uiSchema[key] = {
        ...(prevUiSchema || {}),
        "ui:hidden": true,
        "ui:widget": "hidden",

      };
    }

  });
};